module.exports = __webpack_public_path__ + "img/buddy_eyes-02.3ee01307.svg";